import CONFIGURACIONES from "../../../../util/constants";
import WaveButton from "../../../global/WaveButton";

import { useForm } from "react-hook-form";
import React, {useEffect, useMemo, useState} from "react";
import OWASP from "../../../../util/owasp";

import {el, es} from "date-fns/locale";
import { parse, format } from "date-fns";
import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {Http} from "../../../../helpers/Http";

registerLocale("es-sunday", {
    ...es,
    options: {
        ...es.options,
        weekStartsOn: 0, // 0 = Domingo, 1 = Lunes
    },
});
const MantEvaluation = ({ MySwal, title, idEdit, fnCrear, showCreate, zona, agencia, list, icon, tiposProducto, destinosCredito,            
                            clasePrestamoSelect, setClasePrestamoSelect, setClasePretamoCredito,
                            tiposCredito, clasesPrestamo, user, showSpinnerLoader, setItemSelected }) => {
    const {handleSubmit, reset, register, setValue, formState: {errors}} = useForm({mode: "onChange"});
    const [clienteId, setClienteId] = useState(CONFIGURACIONES.INIT.NUMBER);
    const [showAccepted, setShowAccepted] = useState(CONFIGURACIONES.INIT.STATUS_TRUE);
    const [searchTerm, setSearchTerm] = useState(CONFIGURACIONES.INIT.STRING);
    const [isBloqueado, setIsBloqueado] = useState(CONFIGURACIONES.INIT.STATUS_TRUE);
    const [direcciones, setDirecciones] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [tipoCreditoRefId, setTipoCreditoRefId] = useState(CONFIGURACIONES.INIT.NUMBER);

    const onSubmit1 = (form) => {
        form['zonaId'] = zona;
        form['agenciaId'] = agencia;
        
        let formData = {
            'tipoCreditoId': form.tipoCreditoId,
            'tipoCredito': form.tipoCredito,
            'tipoProducto': form.tipoProducto,
            'productoId': form.productoId,
            'destinoCredito': form.destinoCredito,
            'clasePrestamo': form.clasePrestamo,
            'comentarioEvaluacion': form.comentarioEvaluacion,
            'solicitudId': form.solicitudId,
        }
        fnCrear(formData, 'etapa01');
    };

    const filteredData = list.filter((item) =>
        item.numeroDocumento.toLowerCase().includes(searchTerm.toLowerCase()) || item.cliente.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleCheck = (id) => {
        setIsBloqueado(CONFIGURACIONES.INIT.STATUS_FALSE);
        setClienteId(id);
        setValue('solicitudId', id);
        fnSearchForId(id, zona, agencia);
    };


    const fnSearchForId = (id, zona, agencia) => {
        if (!agencia || !zona) { return; }
        showSpinnerLoader();
        let data = {
            body: {
                'agenciaId': agencia,
                'zonaId': zona,
                'usuarioRegistro': user.user,
            }
        }
        Http().post(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/evaluacion/${id}`, data).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setItemSelected(rpta.data);
                setValue('tipoCreditoSelect',`${rpta.data.tipoCreditoId != CONFIGURACIONES.INIT.STRING?rpta.data.tipoCreditoId+'@@'+rpta.data.tipoCredito:''}`);
                setTipoCreditoRefId(rpta.data.tipoCreditoId);
                setValue('tipoCreditoId', rpta.data.tipoCreditoId);
                setValue('tipoCredito', rpta.data.tipoCredito);
                setValue('tipoProductoSelect', `${rpta.data.productoId != CONFIGURACIONES.INIT.STRING?rpta.data.productoId+'@@'+rpta.data.tipoProducto:''}`);
                setValue('productoId', rpta.data.productoId);
                setValue('tipoProducto', rpta.data.tipoProducto);
                setValue('destinoCredito', rpta.data.destinoCredito);
                setValue('clasePrestamo', rpta.data.clasePrestamo);
                setValue('comentarioEvaluacion', rpta.data.comentarioEvaluacion);
                setDirecciones(rpta.data.direcciones);

                setClasePrestamoSelect(clasesPrestamo.filter((el) => el.tipo_credito !== 'NUEVO'));

                if(rpta.data.condicion === 'NUEVO') {
                    setClasePrestamoSelect(clasesPrestamo.filter((el) => el.tipo_credito === 'NUEVO'));
                    setValue('clasePrestamo', 'NUEVO');
                    setClasePretamoCredito('NUEVO');
                    console.log('condicion', clasesPrestamo.filter((el) => el.tipo_credito === 'NUEVO'))
                }

            }
        });
    };

    const productosSelect = useMemo(() => {
        if (tipoCreditoRefId == 0) return [];
        
        return tiposProducto.filter(prod => prod.tipo_credito_id == tipoCreditoRefId);
        
    }, [tiposProducto, tipoCreditoRefId]);
    
    useEffect(() => {
        setIsBloqueado(CONFIGURACIONES.INIT.STATUS_TRUE);
        setClienteId(CONFIGURACIONES.INIT.NUMBER);
        setValue('solicitudId', CONFIGURACIONES.INIT.STRING);
        reset();
    }, [zona, agencia, list]);

    
    // useEffect(() => {
    //     setValue("cargoEmpleadoId", cargoEmpleadoRefId); // Limpia el select de cargo
    // }, [cargoEmpleadoRefId, setValue]);

    return (
        <>
            { idEdit >= CONFIGURACIONES.INIT.NUMBER && <>
            {/* <h5 className="card-title font-weight-bold">Editando Empleado</h5> */}
                <div className="card-content">
                    <form action="" className="form" onSubmit={handleSubmit(onSubmit1)} autoComplete="off">
                        <div className="row">
                            <div className="col-xs-12 col-md-12">
                                <h5 className="card-title font-weight-bold"><i className={`mdi ${icon}`}></i> {title}</h5>

                                <div className="row mt-3">
                                    <div className="col-xs-12 col-md-12">
                                        {/* Input alineado con la tabla */}
                                        <div className="row">

                                            <div className="col-md-1">
                                                <label htmlFor="buscar" className="control-label col-form-label-sm">Cliente</label>
                                            </div>
                                            <div className="col-md-5 pl-0">
                                                <input
                                                    type="text"
                                                    name="buscar"
                                                    id="buscar"
                                                    className="form-control form-control-sm w-50 me-2"
                                                    placeholder="Buscar..."
                                                    onChange={(e) => {
                                                        setSearchTerm(e.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>



                                        {/* Tabla */}
                                        <div className="table-responsive">
                                            <table className="table table-bordered compact-table align-middle text-nowrap">
                                                <thead className="bg-success text-white">
                                                <tr>
                                                    <th className="text-center">Seleccionar</th>
                                                    <th>T. Documento</th>
                                                    <th>Num. Documento</th>
                                                    <th>Cliente</th>
                                                    <th>Monto</th>
                                                    <th>Actividad</th>
                                                    <th>Condición</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {filteredData.length > 0? (
                                                    filteredData.map((el, index) => (
                                                        <React.Fragment key={index}>
                                                        <tr>
                                                            <td className="text-center">
                                                                <input type="radio" className="text-center" checked={el.id === clienteId } onChange={() => handleCheck(el.id)}/>
                                                            </td>
                                                            <td>{el.tipoDocumento}</td>
                                                            <td>{el.numeroDocumento}</td>
                                                            <td>{el.cliente}</td>
                                                            <td>{el.montoSolicitado}</td>
                                                            <td>{el.actividadNegocio}</td>
                                                            <td>{el.condicion}</td>
                                                        </tr>
                                                        </React.Fragment>))
                                                ): (<tr><td className="align-middle p-2 bg-white text-danger font-bold" colSpan={7}>{CONFIGURACIONES.MESSAGES.LIST_EMPTY}</td></tr>)}

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <hr className="bg-success pt-1" />
                                <div className="row mt-3">
                                    <div className="col-md-12">
                                        <div className="d-flex align-items-center pb-2">
                                            <h6 className="mr-2 mb-0">Información del Titular</h6>
                                        </div>
                                    </div>

                                    {!isBloqueado && <div className="col-xs-12 col-md-12">
                                        <div className="table-responsive">
                                            <table
                                                className="table table-bordered compact-table align-middle text-nowrap">
                                                <thead className="table-warning">
                                                <tr>
                                                    <th>Tipo de Dirección</th>
                                                    <th>Departamento</th>
                                                    <th>Provincia</th>
                                                    <th>Distrito</th>
                                                    <th>Dirección</th>
                                                    <th>Teléfono</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {direcciones.length >0?(
                                                    direcciones.map((el, index) => (
                                                        <React.Fragment key={index}>
                                                            <tr>
                                                                <td>{el.tipo}</td>
                                                                <td>{el.departamento}</td>
                                                                <td>{el.provincia}</td>
                                                                <td>{el.distrito}</td>
                                                                <td>{el.direccion}</td>
                                                                <td>{el.telefono}</td>
                                                            </tr>
                                                        </React.Fragment>
                                                    ))
                                                ): (<tr><td className="align-middle p-2 bg-white text-danger font-bold" colSpan={6}>{CONFIGURACIONES.MESSAGES.LIST_EMPTY}</td></tr>)}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>}

                                    <div className="col-xs-12 col-md-12">
                                        <div className="row">
                                            <div className="col-xs-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="tipoCreditoSelect" className="control-label col-form-label">Tipo de Crédito <span className="text-danger">*</span></label>
                                                    <select
                                                        {...register("tipoCreditoSelect", {
                                                            required: OWASP.REQUIRED,
                                                            disabled: isBloqueado,
                                                            onChange: (e) => {
                                                                let ref = e.target.value.split('@@');
                                                                setTipoCreditoRefId(ref[0]);
                                                                setValue('tipoCreditoId', ref[0]);
                                                                setValue('tipoCredito', ref[1]);
                                                                setValue('tipoProductoSelect', CONFIGURACIONES.INIT.STRING);
                                                                setValue('productoId', CONFIGURACIONES.INIT.STRING);
                                                                setValue('tipoProducto', CONFIGURACIONES.INIT.STRING);
                                                            }
                                                        })} className="form-control" id="tipoCreditoSelect"  defaultValue={""}
                                                    >
                                                        <option value="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE}>Seleccione</option>
                                                        {
                                                            tiposCredito.map((el, index) => (
                                                                <option key={index} value={`${el.id}@@${el.nombre}`}>{el.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small className="invalid-feedback"> { errors.tipoCredito && errors.tipoCredito.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-xs-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="tipoProductoSelect" className="control-label col-form-label">Tipo de Producto <span className="text-danger">*</span></label>
                                                    <select
                                                        {...register("tipoProductoSelect", {
                                                            required: OWASP.REQUIRED,
                                                            disabled: isBloqueado,
                                                            onChange: (e) => {
                                                                let elem = e.target.value.split('@@');
                                                                setValue('productoId', elem[0]);
                                                                setValue('tipoProducto', elem[1]);
                                                            }
                                                        })} className="form-control" id="tipoProductoSelect"  defaultValue={""}
                                                    >
                                                        <option value="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE}>Seleccione</option>
                                                        {
                                                            productosSelect.map((el, index) => (
                                                                <option key={index} value={`${el.id}@@${el.nombre}`}>{el.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <input type="hidden" name="" {...register("tipoCreditoId", {required: OWASP.REQUIRED}) }/>
                                                    <input type="hidden" name="" {...register("tipoCredito", {required: OWASP.REQUIRED}) }/>
                                                    <input type="hidden" name="" {...register("productoId", {required: OWASP.REQUIRED}) }/>
                                                    <input type="hidden" name="" {...register("tipoProducto", {required: OWASP.REQUIRED}) }/>
                                                    <small className="invalid-feedback"> { errors.tipoProductoSelect && errors.tipoProductoSelect.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-xs-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="destinoCredito" className="control-label col-form-label">Destino del Crédito <span className="text-danger">*</span></label>
                                                    <select
                                                        {...register("destinoCredito", {
                                                            required: OWASP.REQUIRED,
                                                            disabled: isBloqueado,
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.GENERAL,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            },
                                                            onChange: (e) => {
                                                            }
                                                        })} className="form-control" id="destinoCredito"  defaultValue={""}
                                                    >
                                                        <option value="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE}>Seleccione</option>
                                                        {
                                                            destinosCredito.map((el, index) => (
                                                                <option key={index} value={el.nombre}>{el.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small className="invalid-feedback"> { errors.destinoCredito && errors.destinoCredito.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-xs-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="clasePrestamo" className="control-label col-form-label">Clase de Préstamo <span className="text-danger">*</span></label>
                                                    <select
                                                        {...register("clasePrestamo", {
                                                            required: OWASP.REQUIRED,
                                                            disabled: isBloqueado,
                                                            onChange: (e) => {
                                                                setClasePretamoCredito(e.target.value);
                                                            }
                                                        })} className="form-control" id="clasePrestamo"  defaultValue={""}
                                                    >
                                                        <option value="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE}>Seleccione</option>
                                                        {
                                                            clasePrestamoSelect.map((el, index) => (
                                                                <option key={index} value={el.nombre}>{el.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small className="invalid-feedback"> { errors.clasePrestamo && errors.clasePrestamo.message }</small>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-xs-12 col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="comentarioEvaluacion" className="control-label col-form-label">Comentario</label>
                                                    <textarea
                                                        {...register("comentarioEvaluacion", {disabled: isBloqueado})}
                                                        className="form-control no-resize" rows="2" id="comentarioEvaluacion" placeholder=""></textarea>
                                                    <small className="invalid-feedback"> { errors.comentarioEvaluacion && errors.comentarioEvaluacion.message }</small>
                                                </div>
                                            </div>

                                            <input type="hidden" name="solicitudId"
                                               {...register('solicitudId', {
                                                   required: OWASP.REQUIRED,
                                                   pattern: {
                                                       value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                       message: OWASP.MESSAGES.DEFAULT
                                                   }
                                               })} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="action-form mt-3 d-flex justify-content-end">
                            <div className="form-group m-0 p-0 text-left">
                                {showCreate && clienteId > 0 && showAccepted && <WaveButton type="submit" className="btn btn-sm btn-outline-success waves-effect ml-2">
                                    <i className="mdi mdi-arrow-right-bold"></i> Continuar
                                </WaveButton>}
                            </div>
                        </div>
                    </form>
               </div>
            </>
            }
        </>
    )
}
export default MantEvaluation;